// extracted by mini-css-extract-plugin
export default {"question":"styles_question__WX8VB"};